<template>
  <Table
    :total="total"
    :attr="{
      dense: true,
      'no-data-text': $t('rules.noData'),
      'item-key': 'id',
      class: 'table-cus-footer',
    }"
    ref="table"
    :itemsPerPage="10"
    :itemsPerPageOptions="[10, 20, 30, 50, 100, 200, 500]"
    :headers="headers"
    :items="items"
    defaultSortBy="status"
    :funReset="loadData"
  >
    <!-- pass all the <template> slots -->
    <template v-for="(_index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-for="(_index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </Table>
</template>

<script>
import Table from './index.vue';

export default {
  components: { Table },
  props: {
    getData: Function,
    headers: Array,
    defaultSortBy: String,
  },
  data() {
    return {
      total: 0,
      items: [],
    };
  },
  onMounted() {
    this.loadData();
  },
  methods: {
    async loadData(variables) {
      if (this.getData) {
        const result = await this.getData({
          filter: variables?.filter,
          pagination: variables?.pagination,
          orderBy: variables?.orderBy,
        });

        this.total = result.total;
        this.items = result.items;
      }
    },
    reset() {
      this.$refs.table.reset?.();
    },
  },
};
</script>
